import {Skeleton as MuiSkeleton} from "@mui/material";
import {FC} from "react";

interface SkeletonProps {
    message?: string,
    numHeaderLines?: number,
    numLines?: number,
    useHeader?: boolean
    useLines?: boolean,
    noMargin?: boolean,
}

const Skeleton: FC<SkeletonProps> = props => {
    let {useHeader, numHeaderLines, useLines, numLines, message, noMargin} = props;

    if (!message) message = 'Waiting for Data...';
    if (!useHeader) useHeader = true;
    if (!numHeaderLines) numHeaderLines = 1;
    if (!useLines) useLines = true;
    if (!numLines) numLines = 3;

    let headerLines = []
    if (useHeader) {
        for (let i = 0; i < numHeaderLines; i++) {
            headerLines.push(<MuiSkeleton key={i} variant="circular" height={24} width={24}/>);
        }
    }

    let lines = [];
    if (useLines) {
        for (let i = 0; i < numLines; i++) {
            lines.push(<MuiSkeleton key={i} variant="rounded" width={240} height={24}></MuiSkeleton>);
        }
    }

    return (
        <div id='skeleton-wrapper' style={{margin: noMargin ? 0 : '1em'}}>
            <div style={{marginBottom: '1em'}}>{message}</div>

            {useHeader && <header style={{marginBottom: '8px', backgroundColor: 'white'}}>{headerLines}</header>}

            {useLines && <div style={{display: 'flex', flexDirection: 'column', rowGap: '5px'}}>{lines}</div>}
        </div>
    );
}

export default Skeleton;
